import React from 'react';
export function Terms() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-5336">
      <h1 className="text-4xl font-bold text-white mb-8 font-title" data-id="element-5337">
        Terms of Service
      </h1>

      <div className="space-y-8 text-neutral-300 font-body leading-relaxed" data-id="element-5338">
        <section data-id="element-5339">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-5340">
            1. Acceptance of Terms
          </h2>
          <p data-id="element-5341">
            By accessing or using Giga ("Service"), you agree to be bound by
            these Terms of Service. If you disagree with any part of the terms,
            you may not access the Service. These terms apply to all visitors,
            users, and others who access or use the Service.
          </p>
        </section>

        <section data-id="element-5342">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-5343">
            2. Account Terms
          </h2>
          <ul className="list-disc pl-5 space-y-2" data-id="element-5344">
            <li data-id="element-5345">You must be 18 years or older to use this Service.</li>
            <li data-id="element-5346">
              You must provide your legal full name, a valid email address, and
              any other information requested in order to complete the signup
              process.
            </li>
            <li data-id="element-5347">
              You are responsible for maintaining the security of your account
              and password. Giga cannot and will not be liable for any loss or
              damage from your failure to comply with this security obligation.
            </li>
            <li data-id="element-5348">
              You are responsible for all content posted and activity that
              occurs under your account.
            </li>
          </ul>
        </section>

        <section data-id="element-5349">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-5350">
            3. API Usage
          </h2>
          <p className="mb-4" data-id="element-5351">
            Customers may access their Giga account data via an API (Application
            Program Interface). Any use of the API, including use of the API
            through a third-party product that accesses Giga, is bound by these
            Terms of Service plus the following specific terms:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-5352">
            <li data-id="element-5353">
              You expressly understand and agree that Giga shall not be liable
              for any direct, indirect, incidental, special, consequential or
              exemplary damages, including but not limited to, damages for loss
              of profits, goodwill, use, data or other intangible losses
              resulting from your use of the API.
            </li>
            <li data-id="element-5354">
              Abuse or excessively frequent requests to Giga via the API may
              result in the temporary or permanent suspension of your account's
              access to the API.
            </li>
          </ul>
        </section>

        <section data-id="element-5355">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-5356">
            4. Data and Privacy
          </h2>
          <p data-id="element-5357">
            Your use of the Service is also governed by our Privacy Policy. Giga
            claims no intellectual property rights over the material you provide
            to the Service. Your profile and materials uploaded remain yours.
          </p>
        </section>

        <section data-id="element-5358">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-5359">
            5. Termination
          </h2>
          <p data-id="element-5360">
            We may terminate or suspend access to our Service immediately,
            without prior notice or liability, for any reason whatsoever,
            including without limitation if you breach the Terms. All provisions
            of the Terms which by their nature should survive termination shall
            survive termination, including, without limitation, ownership
            provisions, warranty disclaimers, indemnity and limitations of
            liability.
          </p>
        </section>

        <section data-id="element-5361">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-5362">
            6. Limitation of Liability
          </h2>
          <p data-id="element-5363">
            In no event shall Giga, nor its directors, employees, partners,
            agents, suppliers, or affiliates, be liable for any indirect,
            incidental, special, consequential or punitive damages, including
            without limitation, loss of profits, data, use, goodwill, or other
            intangible losses, resulting from your access to or use of or
            inability to access or use the Service.
          </p>
        </section>

        <section data-id="element-5364">
          <p className="text-sm text-neutral-500 mt-12" data-id="element-5365">
            Last updated: May 2026
          </p>
        </section>
      </div>
    </div>;
}